angular.module 'zc.projects'

.directive 'zcAdvertisingsList', (ProjectAdvertising) ->
  restrict: "E"
  scope:
    project: "="
  templateUrl: "/templates/projects/directives/projects/advertisings_list.html"

  link: (scope, element, attrs) ->
    scope.advertisings = []
    ProjectAdvertising.all scope.project.id
    .then (res) ->
      scope.advertisings = res



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/advertisings_list.directive.coffee